import { createContext } from "react";
import { EditorUiContextData } from "./types";

export const EditorUiContext = createContext({} as EditorUiContextData);
